import { render, staticRenderFns } from "./BlogPostView.vue?vue&type=template&id=29b86d5c"
import script from "./BlogPostView.vue?vue&type=script&lang=js"
export * from "./BlogPostView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports